import {
  B2C_ONBOARDING_PAGES,
  FEDERAL_STATES,
  TRACK_EVENTS,
  WESER_EMS_FILTERED_ZIPCODES,
} from "core/consts";
import Tile, { TILETYPE } from "ds_legacy/components/TileButton";
import { HorizontalLayout, VerticalLayout } from "ds_legacy/materials/layouts";
import { margin, responsiveCSS } from "ds_legacy/materials/metrics";
import ZipcodesSelect from "dsl/atoms/ZipcodesSelect";
import { USER_FILTER_TREATMENT_LOCATION } from "dsl/organisms/Filters/consts";
import { useTracking } from "react-tracking";
import styled from "styled-components";
import OnboardingCard, { PageProps, testIds } from "../common";

const TileWrapper = styled(HorizontalLayout)`
  margin: ${margin(9, 0)};
  width: 100%;
  ${responsiveCSS({
    desktop: [`justify-content: flex-start`],
    mobile: [`justify-content: center`],
    tablet: [`justify-content: center`],
  })};
`;

export default function Location({
  filters,
  navigateToPage,
  setFilters,
  translations,
}: PageProps) {
  const { trackEvent } = useTracking();
  return (
    <OnboardingCard
      data-testid={testIds.location}
      navigateToPage={navigateToPage}
      title={translations.bToC.onboardingScreens.titleWhereToSearch}
    >
      <VerticalLayout margin={margin(2, 1)}>
        <div data-testid={testIds.locationInput}>
          <ZipcodesSelect
            elementName="location"
            federalState={FEDERAL_STATES.NIEDERSACHSEN}
            filteredZipcodes={WESER_EMS_FILTERED_ZIPCODES}
            noOptionsText={translations.bToC.noResultsWithZipCodeLimitation}
            placeholder={translations.bToC.filterDrawer.searchRadiusPlaceholder}
            required
            withPortal
            onChange={(value) => {
              if (value)
                return setFilters({
                  type: USER_FILTER_TREATMENT_LOCATION,
                  value,
                });
            }}
          />
        </div>
        <TileWrapper aligned>
          <Tile
            label={translations.bToC.filterDrawer.showResults}
            tileType={TILETYPE.B2C}
            onClick={() => {
              trackEvent({
                name: TRACK_EVENTS.B2C_ONBOARDING_SHOW_RESULTS_BUTTON_CLICKED,
              });
              trackEvent({
                name: TRACK_EVENTS.DASHBOARD_FILTERS,
                search_target: filters.zipcode?.id,
              });
              navigateToPage(B2C_ONBOARDING_PAGES.LOADING);
            }}
          />
        </TileWrapper>
      </VerticalLayout>
    </OnboardingCard>
  );
}
